import { render, staticRenderFns } from "./PriceForecast.vue?vue&type=template&id=1410e89e&scoped=true&"
import script from "./PriceForecast.vue?vue&type=script&lang=js&"
export * from "./PriceForecast.vue?vue&type=script&lang=js&"
import style0 from "./PriceForecast.vue?vue&type=style&index=0&id=1410e89e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1410e89e",
  null
  
)

export default component.exports